import(/* webpackMode: "eager", webpackExports: ["RegisterFormWithRedirect"] */ "/vercel/path0/src/app/[locale]/(auth)/register/RegisterFormWithRedirect.tsx");
